// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logout[data-v-3dff8486]{min-height:100vh;display:flex;justify-content:center;align-items:center}@media(max-width:767px){.logout .nav-logo-mobile[data-v-3dff8486]{left:50%;transform:translateX(-80px)}}", ""]);
// Exports
module.exports = exports;
